// 导入vuex 装饰器方法
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { setLS, getLS } from '@/utils/storage'

// app状态接口
export interface IAppState {
  sidebar: {
    opened: boolean
    withoutAnimation: boolean
  }
}

// 动态模块定义
// dynamic:boolean 在store创建之后，再添加到store中。
// 开启dynamic之后必须提供下面的属性
// name: string 指定模块名称
// store: Vuex.Store实体提供初始的store
@Module({ dynamic: true, store, name: 'app' })
class App extends VuexModule implements IAppState {
  // 定义state
  public sidebar = {
    opened: getLS('sidebarStatus') !== 'closed',
    withoutAnimation: false
  }

  public pageInfo: any = {} // 各页面分页信息汇总

  public uploadDisabled: boolean = false // 图片上传时禁止上传其他图片

  public languageList: any[] = []

  @Mutation
  private SET_PAGE_INFO(info: any) {
    this.pageInfo[info.name] = info
  }

  @Mutation
  private SET_UPLOAD_DISABLED(disabled: boolean) {
    this.uploadDisabled = disabled
  }

  @Mutation
  private SET_LANGUAGES(list: any[]) {
    this.languageList = list
  }

  // 修改 state
  @Mutation
  private TOGGLE_SIDEBAR(withoutAnimation: boolean) {
    this.sidebar.opened = !this.sidebar.opened
    this.sidebar.withoutAnimation = withoutAnimation
    if (this.sidebar.opened) {
      setLS('sidebarStatus', 'opened')
    } else {
      setLS('sidebarStatus', 'closed')
    }
  }

  @Mutation
  private CLOSE_SIDEBAR(withoutAnimation: boolean) {
    this.sidebar.opened = false
    this.sidebar.withoutAnimation = withoutAnimation
    setLS('sidebarStatus', 'closed')
  }

  @Action
  public ToggleSideBar(withoutAnimation: boolean) {
    this.TOGGLE_SIDEBAR(withoutAnimation)
  }

  @Action
  public CloseSideBar(withoutAnimation: boolean) {
    this.CLOSE_SIDEBAR(withoutAnimation)
  }

  @Action
  public SetPageInfo(info: any) {
    this.SET_PAGE_INFO(info)
  }

  @Action
  public SetUploadDisabled(disabled: boolean) {
    this.SET_UPLOAD_DISABLED(disabled)
  }

  @Action
  public GetLanguages(languages: any[]) {
    this.SET_LANGUAGES(languages)
  }
}

export const AppModule = getModule(App)
